<template>
  <div v-bind="$attrs">
    <check-authorization :requiresAuthorizations="['listar unidades administrativas']">
      <x-select
        v-model="unidad"
        dispatchPath="administrativeUnitModule/getAdministrativeUnits"
        getterListPath="administrativeUnitModule/getAdministrativeUnits"
        :formatListWith="['id', 'nombre']"
        no-validate
        default-text="Seleccionar unidad administrativa"
      />
    </check-authorization>
  </div>
</template>

<script>
export default {
  name: 'XSelectUnidadAdministrativa',

  data () {
    return {
      unidad: null
    }
  },

  watch: {
    unidad: {
      immediate: true,
      handler (value) {
        this.onInput(value)
      }
    }
  },

  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
